/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
} from './Bed';

/**
 * 
 * @export
 * @interface BulkUpdateBedsRequest
 */
export interface BulkUpdateBedsRequest {
    /**
     * 
     * @type {Array<Bed>}
     * @memberof BulkUpdateBedsRequest
     */
    beds: Array<Bed>;
}

/**
 * Check if a given object implements the BulkUpdateBedsRequest interface.
 */
export function instanceOfBulkUpdateBedsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "beds" in value;

    return isInstance;
}

export function BulkUpdateBedsRequestFromJSON(json: any): BulkUpdateBedsRequest {
    return BulkUpdateBedsRequestFromJSONTyped(json, false);
}

export function BulkUpdateBedsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateBedsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'beds': ((json['beds'] as Array<any>).map(BedFromJSON)),
    };
}

export function BulkUpdateBedsRequestToJSON(value?: BulkUpdateBedsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'beds': ((value.beds as Array<any>).map(BedToJSON)),
    };
}

